<template>
    <div class="page-reply-updateSucess">
        <div
            v-for="(item, index) in getNewAccountList"
            :key="index"
            class="customer-inner"
        >
            <img
                :src="item.icon"
                class="card-img"
            >
            <div class="card-content">
                <div class="card-content-text">
                    <p class="content-text-title">
                        {{ item.name }}
                    </p>
                    <p
                        v-if="Number(item.verifyType) !== 0"
                        class="content-text-icon"
                    >
                        <v-icon
                            v-if="Number(item.type) === 1"
                            size="14"
                            name="icon-wx-authed"
                        />
                        <v-icon
                            v-else
                            size="14"
                            name="icon-authed"
                        />
                    </p>
                </div>
                <div class="card-content-des">
                    <span>{{ Number(item.type) == 1 ? $t('微信') : $t('QQ') }}</span>
                    <span>{{ Number(item.accountType) == 1 ? $t('订阅号') : $t('服务号') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const qqImg = '//bqq.gtimg.com/qidian/src/themes/blue/mp/account/images/QQdefault.png';
const wxImg = '//bqq.gtimg.com/qidian/src/themes/blue/mp/account/images/weixindefault.png';
export default {
    name: '',
    props: {
        value: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            accountList: window.data.data && window.data.data.accountList,
            newAccountList: [],
        };
    },
    computed: {
        getNewAccountList() {
            const aIds = this.value.succ;
            const newAccountList = [];
            if (this.value.succ) {
                for (let i = 0; i < aIds.length; i++) {
                    for (let j = 0, jL = this.accountList.length; j < jL; j++) {
                        if (Number(aIds[i]) === Number(this.accountList[j].accountID)) {
                            // eslint-disable-next-line vue/no-side-effects-in-computed-properties, no-nested-ternary
                            this.accountList[j].icon = this.accountList[j].icon
                                ? this.accountList[j].icon : (this.accountList[j].type === 1 ? wxImg : qqImg);
                            newAccountList.push(this.accountList[j]);
                        }
                    }
                }
            }
            return newAccountList;
        },
    },
    methods: {

    },
};
</script>

<style lang="less" scoped>
.page-reply-updateSucess {
    .customer-inner {
        border: var(--border-normal) solid var(--color-border-normal);
        width: 286px;
        height: 40px;
        display: flex;
        align-items: center;
        padding: var(--spacing-base-loose);
        margin-bottom: var(--spacing-base);
        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
         .card-content {
                text-align: left;
                margin-left: var(--spacing-base-loose);
                .card-content-text {
                    display: flex;
                    .content-text-icon {
                        height: 14px;
                        margin: 1px 3px 0;
                    }
                }
                .card-content-des {
                    color: var(--color-text-caption);
                    font-size: 12px;
                }
            }
    }
}
</style>
